import { useMutation } from 'react-query';
import notificationError from '@/utils/functions/notificationError';
import pecaAiServices from './pecaAi.services';

export function useOperationalPecaAiProductGroupSearch() {
  return useMutation(pecaAiServices.searchProductGroup, {
    onError(error) {
      notificationError(error);
    },
  });
}

export function useOperationalPecaAiProductsSearch() {
  return useMutation(pecaAiServices.searchProducts, {
    onError(error) {
      notificationError(error);
    },
  });
}
